import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ClubOverviewService } from '~features/club-overview/club-overview.service';
import { NotificationType } from '~core/enum';
import { Club } from '~core/models';
import { ClubService, DefaultNotificationService, StorageService } from '~core/services';
import { ClubStatusTranslationsService, ClubTranslationsService } from '~shared/translations';
import {FormFieldImageUploadComponent} from '~shared/components/form-fields/form-field-image-upload/form-field-image-upload.component';

/**
 * Component that lets you upload a Club logo and communicated with the Club API
 */
@Component({
  selector: 'app-upload-club-logo',
  templateUrl: './upload-club-logo.component.html',
  styleUrls: ['../../../pages/club-settings/club.component.scss']
})
export class UploadClubLogoComponent implements OnInit, OnDestroy {
  @ViewChild(FormFieldImageUploadComponent) imageUpload: FormFieldImageUploadComponent;
  public clubForm: UntypedFormGroup;
  @Input() public selectedClub: Club;
  @Output() public logoUploaded: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    public clubService: ClubService,
    public clubOverviewService: ClubOverviewService,
    private notificationService: DefaultNotificationService,
    private clubTranslations: ClubTranslationsService,
    private formBuilder: UntypedFormBuilder,
    private storage: StorageService,
    private clubStatuses: ClubStatusTranslationsService
  ) { }

  public ngOnInit(): void {
    this.clubForm = this.formBuilder.group({
      id: [this.selectedClub.id],
      logo: [this.selectedClub.logo]
    });
  }

  public ngOnDestroy(): void { }

  /**
   * Upload a logo for a club-overview.
   */
  public uploadLogo(): void {
    if (this.imageUpload.isValidFileType) {
      this.clubOverviewService.updateLoading = true;
      const formData: FormData = new FormData();
      formData.append('file', this.imageUpload.fileToUpload);
      this.clubService.uploadLogo(formData).pipe(first())
        .subscribe({
          next: (logoResponse: any) => {
            this.clubForm.patchValue({ logo: `api/media/${logoResponse.id}` });
            this.clubService.updateClub(this.clubForm.value).pipe(first())
              .subscribe({
                next: (res: Club) => {
                  this.clubOverviewService.updateLoading = false;
                  this.storage.updateSelectedClub(new Club(res, this.clubStatuses));
                  this.logoUploaded.emit('uploaded');
                  this.notificationService.showNotification({
                    type: NotificationType.SUCCESS,
                    message: this.clubTranslations.i18nSuccessLogoClubUpload
                  });
                },
                error: (error: Error) => {
                  this.logoUploaded.emit('error');
                  this.clubOverviewService.updateLoading = false;
                  this.notificationService.showNotification({
                    type: NotificationType.ALERT,
                    message: this.clubTranslations.i18nErrorClubUpdate
                  });
                }
              });
          },
          error: (err: Error) => {
            this.notificationService.showNotification({
              type: NotificationType.ALERT,
              message: this.clubTranslations.i18nErrorCannotUploadLogo
            });
            this.clubOverviewService.updateLoading = false;
          }
        });
    }
  }

}
